export default "__VITE_ASSET__DPAJRl69__"